import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import {
    AirconSearchProduct,
    AirconSearchResponse
} from '@brokerportal/common/models/application/aircon-reference-data.model';

@Injectable({ providedIn: 'root' })
export class AirconReferenceDataService {
    private readonly baseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.useDirectQuoteService ? environment.quoteServiceHost : environment.api.baseUrl;
    }

    /** `product` is only sent when supplied so the existing ZIPP request stays unchanged. */
    searchAirConditioners(query: string, limit = 20, product?: AirconSearchProduct): Observable<AirconSearchResponse> {
        let params = new HttpParams().set('search', query).set('limit', String(limit));
        if (product) {
            params = params.set('product', product);
        }
        return this.httpClient.get<AirconSearchResponse>(
            `${this.baseUrl}/${environment.referenceDataRoute}/air-conditioners`,
            { params }
        );
    }
}
